// extracted by mini-css-extract-plugin
export default {"trainers":"trainers_trainers__wJ6VO","trainers_head":"trainers_trainers_head__jiVhz","boxes":"trainers_boxes__gl9VG","box":"trainers_box__QS7k2"};